import { useContext, memo } from 'react'
import { Box, Divider, Icon, StackView, Typography } from '@telus-uds/components-web'
import Deals from '@telus-uds/palette-allium/build/web/icons/Deals'
import { bool } from 'prop-types'

import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'
import useCart from '../../../hooks/useCart'
import { Container } from './styles'
import { formatCurrency } from '../../../utils/currency'
import { getTotalPAPDiscount, getPAPMessage } from './utils'

const PAPMessage = ({ isInPriceSummary }) => {
  const t = useTranslate()
  const { lang } = useContext(localeContext)
  const { cart } = useCart()
  const getMessage = () => {
    const message = getPAPMessage(cart)
    const discount = getTotalPAPDiscount(cart)
    if (message !== undefined) {
      return t(`priceSummary.papMessage.${message}`, {
        replacements: {
          totalDiscount: formatCurrency(discount.padDiscountAmount, lang, 0)
        }
      })
    }
    // unable to determine, do not render anything to customer
    return undefined
  }

  const renderPap = () => {
    if (isInPriceSummary) {
      return (
        <>
          <Box bottom={3}>
            <StackView space={3} direction="row">
              <Icon icon={Deals} variant={{ size: 'small' }} />
              <div>
                <Typography block align="left" testID="pap-message">
                  {getMessage()}
                </Typography>
              </div>
            </StackView>
          </Box>
          <Box bottom={3}>
            <Divider variant={{ decorative: true }} />
          </Box>
        </>
      )
    }
    return (
      <Box bottom={5}>
        <Container>
          <StackView space={3} direction="row">
            <Icon icon={Deals} variant={{ size: 'small' }} />
            <Typography testID="pap-message">{getMessage()}</Typography>
          </StackView>
        </Container>
      </Box>
    )
  }

  if (!getMessage()) return null
  return renderPap()
}
PAPMessage.propTypes = {
  isInPriceSummary: bool
}

PAPMessage.defaultProps = {
  isInPriceSummary: false
}

export default memo(PAPMessage)
